<template>
    <div class="homepage">
        <Nav></Nav>
        <div class="banner">
            <swiper :options="Banner">
                <!--<swiper-slide v-for="item in bannerList"><img @click="goNovice(item)" :src="item.imgUrl"/></swiper-slide>-->
                <swiper-slide><img :src="imgUrl" @click="goBannerUrl"/></swiper-slide>
            </swiper>
        </div>
        <div class="notice" v-if="isNotice">
            <img src="@/assets/images/home/toolbar_message.png"/>
            <div class="marquee" id="marCon">
                <div class="marWidth">
                    <div id="marquee">{{noticeAd}}</div>
                    <div id="marItem"></div>
                </div>
            </div>
            <img @click="closeNotice" src="@/assets/images/home/home_close.png"/>
        </div>
        <div class="product">
            <div class="title"><span>{{$t("trade.products.tradeProduct")}}</span><img @click="isCutover" src="@/assets/images/home/market_expand.png"/></div>
            <Quote v-if="!isView" :tickList="tickList"></Quote>
            <QuoteView v-if="isView" :tickList="tickList"></QuoteView>
        </div>
        <div class="newsIndex" :class="user.loginname?'':'last'">
            <div class="title"><span>{{$t("trade.products.aboutNews")}}</span><p @click="goNewsList">{{$t("trade.products.more")}}</p></div>
            <IndexNews></IndexNews>
        </div>
        <!--<div class="ad" v-for="item in bottomAd"><img :src="item.imgUrl" @click="goNovice(item)"/></div>-->
        <div id="top-btn" :class="user.loginname?'last':''"><img src="@/assets/images/template/a_backtotop.png"/></div>
        <Bottom></Bottom>
        <tab></tab>
    </div>
</template>
<script>
    require('swiper/dist/css/swiper.css');
    require('@/assets/css/homepage.css');
    import Nav from '@/view/module/Nav.vue'
    import Tab from '@/view/module/Tab.vue'
    import NoData from '@/view/module/NoData.vue'
    import Quote from '@/view/quotation/Quote.vue'
    import QuoteView from '@/view/quotation/QuoteView.vue'
    import IndexNews from '@/view/news/IndexNews.vue'
    import Bottom from '@/view/module/Bottom.vue'
    import {swiper, swiperSlide} from 'vue-awesome-swiper'
    import api from '@/plugins/api'
    import {mapState} from 'vuex'
    export default {
        name: 'Homepage',
        components: {NoData,Nav, Tab, swiper, swiperSlide,Quote,QuoteView,IndexNews,Bottom},
        computed: {
            ...mapState(['quote','user','locale']),
            tickList: {
                get() {
                    let newTickList=[];
                    // for (const i in this.quote.tickList) {
                    //     if(this.uiCodeIDs.indexOf(this.quote.tickList[i].uiCodeID) >= 0){
                    //         newTickList.push(this.quote.tickList[i]);
                    //     }
                    // }
                    
                    let codes = this.uiCodeIDs.split(",");
                    for(const i in codes){
                        for(const j in this.quote.tickList){
                            if(codes[i] == this.quote.tickList[j].uiCodeID){
                                newTickList.push(this.quote.tickList[j]);
                                break;
                            }
                        }
                   
                    }
                    return newTickList;
                }
            }
        },
        data(){
            return{
                bannerList: [],
                noticeAd:'',
                bottomAd:'',
                Banner: {
                    notNextTick: true,
                    // loop: true,
                    loop:false,
                    initialSlide: 0,
                    autoplay: {
                        delay: 3000,
                        stopOnLastSlide: false,
                        disableOnInteraction: true
                    },
                    speed: 800,
                },
                isNotice:false,//轮播
                myMar:0,
                isView:false,
                uiCodeIDs: process.env.VUE_APP_PRODUCTS,
                langs:JSON.parse(process.env.VUE_APP_LANG),
                imgUrl:require("@/assets/images/home/banner_vn.png"),
            }
        },
        created() {
            if (this.locale == "vn") {
                this.langs = this.langs.vn
            } else {
                this.langs = this.langs.en
            }
            const readyData = this.$qs.stringify({
                account: this.user.loginname,
                adPosition: "1|3|4",
                channel: process.env.VUE_APP_TITLE_CHANNEL,
                lang:this.langs
            });
            api.queryForApp(readyData).then(res => {
                if (res) {
                    if (res.status == 200 && res.data.code == 200) {
                        if (res.data.ch_msg) {
                            if(res.data.ch_msg[1]&&res.data.ch_msg[1].length>0) this.bannerList = res.data.ch_msg[1];
                            if(res.data.ch_msg[3]&&res.data.ch_msg[3].length>0) this.noticeAd = res.data.ch_msg[3][0].content;
                            if(res.data.ch_msg[4]&&res.data.ch_msg[4].length>0) this.bottomAd = res.data.ch_msg[4];
                        }
                    }
                }
            });
        },
        methods:{
            Marquee () {
                let marCon = document.getElementById('marCon');
                let marquee = document.getElementById('marquee');
                let marItem = document.getElementById('marItem');
                if (marquee != null && marquee != "") {
                    marItem.innerHTML = marquee.innerHTML;
                    if (marCon.scrollLeft - marItem.offsetWidth >= 0) {
                        marCon.scrollLeft -= marquee.offsetWidth
                    } else {
                        marCon.scrollLeft++
                    }
                }
            },
            closeNotice(){
                this.isNotice=!this.isNotice
            },
            isCutover(){
                this.isView=!this.isView
            },
            goNovice(item) {
                this.$bus.$emit('loading', false);
                window.location.href = item.linkUrl;
            },
            goBannerUrl() {
                this.$bus.$emit('loading', false);
                let url="";
                if (this.locale=="vn") url='https://campaign.cfglobal139.com/vn/zt/referral_2025.html?noneheader=1';
                else url='https://campaign.cfglobal139.com/en/zt/referral_2025.html?noneheader=1';
                this.$router.push({
                    path: '/home/embed', query: {
                        url: url,
                        title:this.$t("trade.bannerTitle")
                    },
                });
            },
            goNewsList() {
                this.$bus.$emit('loading', false);
                this.$router.push({path: '/home/newsList'})
            },
        },
        mounted(){
            this.$bus.$emit('loading', true);
            let mainH = document.getElementById("main");
            mainH.classList.remove('mainFixed');
            this.$nextTick(()=>{
                let speed = 40;//数值越大，速度越慢
                this.myMar = setInterval(this.Marquee, speed);
                let marCon = document.getElementById('marCon');
                if (marCon != null && marCon != "") {
                    marCon.onmouseover = ()=> {
                        clearInterval(this.myMar);
                    };
                    marCon.onmouseout = ()=>{
                        this.myMar = setInterval(this.Marquee, speed);
                    }
                }
            });
            if (this.locale=="vn"){
                this.imgUrl=require("@/assets/images/home/banner_vn.png")
            } else {
                this.imgUrl=require("@/assets/images/home/banner_en.png")
            }
            let backTop = document.getElementById("top-btn"), flag = true, time = null;
            window.onscroll = function () {
                let scroll = document.documentElement.scrollTop||document.body.scrollTop|| window.pageYOffset;
                if (scroll >= 300) {
                    backTop.classList.add("show")
                } else {
                    backTop.classList.remove("show")
                }
                if (!flag) clearInterval(time);
                flag = false;
            };
            backTop.addEventListener('click', function () {
                let scroll = document.documentElement.scrollTop||document.body.scrollTop|| window.pageYOffset;
                time = setInterval(function () {
                    document.body.scrollTop = document.documentElement.scrollTop -= scroll;
                    flag = true;
                    if (document.body.scrollTop == 0) {
                        clearInterval(time);
                        time = null
                    }
                }, 200)
            });
        },
        activated(){
            this.$bus.$emit('loading', true);
        },
    }
</script>
